import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-6 sm:p-8 max-w-7xl mx-auto" }
const _hoisted_2 = { class: "flex items-center justify-between mb-6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-[#6CC551] text-xs font-bold uppercase tracking-widest mb-1" }, "Sliders"),
  /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-extrabold text-[#1E2833]" }, "View Sliders")
], -1)
const _hoisted_4 = { class: "bg-white rounded-2xl border border-gray-100 overflow-hidden mb-5" }
const _hoisted_5 = {
  key: 0,
  class: "flex justify-center py-16"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-8 h-8 rounded-full border-4 border-[#6CC551] border-t-transparent animate-spin" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "w-full text-sm text-left"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", { class: "text-xs text-[#1E2833] uppercase bg-[#6CC551]/10 border-b border-gray-100" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3" }, "Title"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3" }, "View Slider"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3" }, "Edit"),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3" }, "Delete")
  ])
], -1)
const _hoisted_10 = { class: "px-6 py-4 text-gray-500" }
const _hoisted_11 = { class: "px-6 py-4 font-medium text-gray-900" }
const _hoisted_12 = { class: "px-6 py-4" }
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", { class: "px-6 py-4" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "text-xs font-semibold text-blue-500 hover:underline" }, "Edit")
], -1)
const _hoisted_15 = { class: "px-6 py-4" }
const _hoisted_16 = ["onClick"]

import { url, imagesUrl } from '@/functions/endpoint';
import axios from 'axios';
import { ref, watch } from 'vue';
import { decodeEntities } from "@/functions";
import { useRouter } from 'vue-router';
import DeleteModal from "@/components/DeleteModal.vue";
import SuccessMessage from "@/components/SuccessMessage.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import Loader from "@/components/Loader.vue";
import EmptyState from "@/components/EmptyState.vue";
import { Pagination } from 'flowbite-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewSliders',
  setup(__props) {

const sliderId = ref();
const router = useRouter()
let successMessage = ref('');
let showSuccessMessage = ref(false);
const loading = ref(false);
let errorAlert = ref(false);
let errorMessage = ref('');
const perPage = ref(12);
const currentPage = ref(1);
let emptyState = ref(false);

const calculatePostNumber = (index: number) => {
  return (currentPage.value - 1) * perPage.value + index + 1;
};

const deleteModal = ref(false);
const openDeleteModal = (id: number) => {
  sliderId.value = id;
  deleteModal.value = true;
};

const closeDeleteModal = () => {
  deleteModal.value = false;
};

const deleteSlider = async () => {
  try {
    const response = await axios.delete( `${url}/slider/delete/${sliderId.value}`
    );

    deleteModal.value = false;
    successMessage = response.data;
    showSuccessMessage.value = true;

    const deletedIndex = allSliders.value.findIndex((item: any) => item.id === sliderId.value);
    if (deletedIndex !== -1) {
      allSliders.value.splice(deletedIndex, 1);
    }

    setTimeout(() => {
      showSuccessMessage.value = false;
    }, 2000);
  } catch (error: any) {
    deleteModal.value = false;
    errorAlert.value = true;
    errorMessage.value = error.message;

    setTimeout(() => {
      errorAlert.value = false;
    }, 2500);
  }
};

const allSliders: any = ref([]);
const fetchNewsItems = () => {
  loading.value = true;
  axios
    .get(`${url}/slider`, {
      params: {
        page: currentPage.value,
        limit: perPage.value
      }
    })
    .then((response: any) => {
      allSliders.value = response.data[1];
    })
    .catch((error: string) => {
      console.error(error);
    })
    .finally(() => {
      loading.value = false;
    })
};

watch(currentPage, fetchNewsItems);
fetchNewsItems();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_router_link, {
          to: "/admin/add-slider",
          class: "inline-flex items-center gap-2 px-4 py-2 bg-[#6CC551] hover:bg-green-600 text-white text-sm font-semibold rounded-xl transition-colors"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" + Add Slider ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : (_openBlock(), _createElementBlock("table", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allSliders.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id,
                    class: "border-b border-gray-50 hover:bg-gray-50 transition-colors"
                  }, [
                    _createElementVNode("td", _hoisted_10, _toDisplayString(calculatePostNumber(index)), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(item?.title?.slice(0, 80)), 1),
                    _createElementVNode("td", _hoisted_12, [
                      _createElementVNode("a", {
                        target: "_blank",
                        href: `${_unref(imagesUrl)}/uploads/${item.image}`,
                        class: "text-xs font-semibold text-[#6CC551] hover:underline"
                      }, "View Slider", 8, _hoisted_13)
                    ]),
                    _hoisted_14,
                    _createElementVNode("td", _hoisted_15, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (openDeleteModal(item.id)),
                        class: "text-xs font-semibold text-red-500 hover:underline"
                      }, "Delete", 8, _hoisted_16)
                    ])
                  ]))
                }), 128))
              ])
            ])),
        _createVNode(EmptyState, { showEmptyState: _unref(emptyState) }, null, 8, ["showEmptyState"])
      ])
    ]),
    (deleteModal.value)
      ? (_openBlock(), _createBlock(DeleteModal, {
          key: 0,
          onDeletePost: deleteSlider,
          onCloseDeleteModal: closeDeleteModal,
          item: 'slider'
        }))
      : _createCommentVNode("", true),
    _createVNode(SuccessMessage, {
      showSuccessMessage: _unref(showSuccessMessage),
      successMessage: _unref(successMessage)
    }, null, 8, ["showSuccessMessage", "successMessage"]),
    _createVNode(ErrorMessage, {
      errorAlert: _unref(errorAlert),
      errorMessage: _unref(errorMessage)
    }, null, 8, ["errorAlert", "errorMessage"])
  ], 64))
}
}

})